<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-friends-or">
				<rect
					id="Rectangle_15503"
					data-name="Rectangle 15503"
					width="20"
					height="20"
					transform="translate(429 839)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44954" data-name="Mask Group 44954" transform="translate(-429 -839)" clip-path="url(#clip-path-friends-or)">
			<g id="Layer_1-2" transform="translate(429 839)">
				<circle id="Ellipse_934" data-name="Ellipse 934" cx="10" cy="10" r="10" fill="#fff" />
				<path id="Path_33047" data-name="Path 33047" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z" fill="#969bae" />
				<path
					id="Path_33048"
					data-name="Path 33048"
					d="M10.43,3.65a.783.783,0,0,1,.55.68,3.854,3.854,0,0,1-.02.48c-.05.57-.1,1.14-.14,1.71,0,.12-.06.17-.18.21a1.768,1.768,0,0,0-.41.21.55.55,0,0,0-.23.48V9.33c-.39.07-.76.13-1.14.19-.56.1-1.12.19-1.67.29-.12.02-.16-.02-.18-.13-.26-1.26-.51-2.53-.77-3.79-.05-.26-.12-.52-.17-.78a.55.55,0,0,1,.34-.67.6.6,0,0,1,.8.31c.15.39.26.8.39,1.2.29.91.57,1.82.86,2.73.03.08.06.16.09.25a.223.223,0,0,0,.26.16.234.234,0,0,0,.2-.22c.05-.33.09-.66.13-.99.11-.9.22-1.81.33-2.71.03-.26.06-.52.11-.78a.786.786,0,0,1,.61-.7.212.212,0,0,0,.07-.03h.19Z"
					fill="#fff"
				/>
				<path
					id="Path_33049"
					data-name="Path 33049"
					d="M9.08,12.33a2.2,2.2,0,0,1,.8.83c.15.3.25.62.37.93a.249.249,0,0,0,.29.2c.14-.02.23-.09.21-.24a2.21,2.21,0,0,0-.11-.51,3.325,3.325,0,0,0-.92-1.37.26.26,0,0,1,.1-.04c.35-.09.71-.17,1.06-.29a1.174,1.174,0,0,0,.88-1.01,1.818,1.818,0,0,0,0-.33,1.072,1.072,0,0,0,1.05.81,1.136,1.136,0,0,0,1.12-.74c.01,0,.02.01.03.02v3.07a2.181,2.181,0,0,1-.73,1.78,2.34,2.34,0,0,1-1.53.57H8.76a2.211,2.211,0,0,1-1.39-.41,1.506,1.506,0,0,1-.55-.79c-.23-.8-.48-1.59-.68-2.4a1.694,1.694,0,0,1,.38-1.62,1.753,1.753,0,0,1,1.14-.52c.92-.13,1.84-.28,2.76-.42a.669.669,0,0,1,.81.58.723.723,0,0,1-.51.88c-.6.14-1.2.26-1.81.4-.13.03-.25.05-.37.09a.24.24,0,0,0-.17.36c.14.29.3.58.46.86a.236.236,0,0,0,.35.07.219.219,0,0,0,.09-.31c-.07-.15-.14-.29-.21-.43.01,0,.03-.02.04-.03Z"
					fill="#fff"
				/>
				<path
					id="Path_33050"
					data-name="Path 33050"
					d="M12.22,9.26V8.32a.663.663,0,0,1,.27-.58.568.568,0,0,1,.6-.06.6.6,0,0,1,.36.57c.01.66.02,1.33,0,1.99a.6.6,0,0,1-.66.59.622.622,0,0,1-.57-.65V9.27Z"
					fill="#fff"
				/>
				<path
					id="Path_33051"
					data-name="Path 33051"
					d="M10.49,9.34V7.95a2.075,2.075,0,0,1,.03-.43.535.535,0,0,1,.54-.41.582.582,0,0,1,.59.34.87.87,0,0,1,.07.31V10.3a1.543,1.543,0,0,0-.44-.68,1.08,1.08,0,0,0-.78-.29Z"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'FriendOrColleagueSvg',
};
</script>
